<template>
    <b-container class="card-body p-0">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'Expert', params: { id: item.id }}"><h4 class="card-title">{{item.surname}}, {{item.forename}}</h4></router-link>
          <div class="mb-2">
            {{item.title}} | {{item.role}} | {{item.email}} | {{item.phone}} | {{item.country}}
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'Expert',
  props: ['item', 'username']
}
</script>

<style>
</style>
